import { render, staticRenderFns } from "./RegistrationDetail.vue?vue&type=template&id=0a6817d4&scoped=true"
import script from "./RegistrationDetail.vue?vue&type=script&lang=js"
export * from "./RegistrationDetail.vue?vue&type=script&lang=js"
import style0 from "./RegistrationDetail.vue?vue&type=style&index=0&id=0a6817d4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a6817d4",
  null
  
)

export default component.exports